import { MdPerson } from 'react-icons/md'
import { formatCentsLabel } from '../scheduling-format'

interface SchedulingSummaryBarProps {
    /** Nome já carregado do cliente; vazio enquanto ninguém foi escolhido. */
    clientName: string
    /** "Paciente", "Cliente", "Tutor"… conforme o segmento. */
    clientLabel: string
    serviceTypeLabel: string
    isBudgetMode: boolean
    /**
     * Valor do serviço, em centavos, SEM taxa. É o que aparece quando não há
     * forma de pagamento escolhida.
     */
    price: number
    /**
     * Total COM a taxa da forma escolhida, quando ela existe e já está
     * sincronizada com o preço atual. Nulo = mostrar `price`.
     */
    quoteTotal: number | null
    /** "3x no cartão", "Pix"… acompanha o rótulo do valor final. */
    quoteLabel: string | null
}

/**
 * Resumo grudado no topo: para quem e quanto.
 *
 * É a conferência que o operador repete o dia todo e que antes exigia rolar a
 * página inteira de volta.
 */
export default function SchedulingSummaryBar({
    clientName,
    clientLabel,
    serviceTypeLabel,
    isBudgetMode,
    price,
    quoteTotal,
    quoteLabel,
}: SchedulingSummaryBarProps) {
    return (
        <div className="sticky top-0 z-30 flex flex-wrap items-center gap-x-5 gap-y-1 rounded-xl border border-base-300 bg-base-100/95 px-4 py-2.5 backdrop-blur">
            <span className="flex min-w-0 items-center gap-2 text-sm">
                <MdPerson className="shrink-0 text-base text-base-content/40" />
                <span
                    className={`truncate ${clientName ? 'font-medium text-base-content' : 'text-base-content/40'}`}
                >
                    {clientName || `${clientLabel} não selecionado`}
                </span>
            </span>
            <span className="hidden h-4 w-px shrink-0 bg-base-300 sm:block" />
            <span className="text-sm text-base-content/60">
                {serviceTypeLabel}
                {isBudgetMode ? ' · Orçamento' : ''}
            </span>
            <span className="ml-auto flex shrink-0 items-center gap-2">
                <span className="text-xs text-base-content/50">
                    {isBudgetMode
                        ? 'Valor do orçamento'
                        : quoteTotal !== null
                          ? `Valor final · ${quoteLabel}`
                          : 'Valor final'}
                </span>
                <span className="text-base font-bold text-secondary">
                    {formatCentsLabel(quoteTotal !== null ? quoteTotal : price)}
                </span>
            </span>
        </div>
    )
}
